module.exports = __webpack_public_path__ + "img/banner.92bc58b2.png";